/* eslint-disable jsx-a11y/label-has-associated-control */
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import * as Yup from "yup";
// images
import { Col, Container, Row } from "react-bootstrap";
import moment from "moment";
import SelectField from "../../../components/formfields/SelectField";
import { profileSetupAction } from "../actions";
import SubmitLoader from "../../../components/SubmitLoader";
import DateInput from "../../../components/formfields/BirthDateField";
import CustomButton from "../../../components/Buttons/CustomButton";

const validationSchema = Yup.object({
  birthday: Yup.string().required("Birthdate can not be empty"),
  gender: Yup.string().required("gender can not be empty"),
});

function MemberProfile(props) {
  const { activeStep, previousStep, currentStep, getActiveStep, totalSteps } = props;
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const initialState = {
    birthday: "",
    gender: "",
    is_see_other: true,
  };

  // const handleNextStep = () => {
  //   activeStep(currentStep + 1);
  //   nextStep();
  // };

  const handlePrevStep = (e) => {
    e.preventDefault();

    activeStep(currentStep - 1);
    previousStep();
  };

  const handleSubmit = (values) => {
    setLoader(true);
    const data = {
      ...values,
      birthday: moment(values?.birthday).format("MM/DD/YYYY"),
    };
    dispatch(profileSetupAction(data, props, setLoader));
  };
  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col className="my-5" md={10} lg={8} xl={6}>
            <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema} validateOnBlur={false}>
              {({ values, handleChange, handleBlur, setFieldValue, touched, errors }) => {
                return (
                  <Form>
                    <h1 className="text-white">Setup Your Member Profile</h1>
                    <div className="accountCard">
                      <Row>
                        <Col sm={6}>
                          <label aria-hidden style={{ fontWeight: "bold" }}>
                            Birthday
                          </label>
                          <span className="fw-bold">*</span>
                          <DateInput
                            name="birthday"
                            error={error}
                            setError={setError}
                            value={values?.birthday}
                            setFieldValue={setFieldValue}
                            errorMessage="User should always be above 13 years"
                            touched={touched}
                            errors={errors}
                          />
                          {/* {touched.birthday && errors.birthday && <p className="errorMessage">{errors.birthday}</p>} */}
                        </Col>
                        <Col sm={6}>
                          <label aria-hidden style={{ fontWeight: "bold" }}>
                            Pronoun
                          </label>
                          <span className="fw-bold">*</span>
                          <Field id="gender" name="gender" component={SelectField} value={values.gender} onChange={handleChange} onBlur={handleBlur}>
                            <option>Select Your Pronoun</option>
                            <option value="he/him">He/Him</option>
                            <option value="she/her">She/Her</option>
                            <option value="they/them">They/Them</option>
                          </Field>
                        </Col>
                      </Row>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <CustomButton type="button" variant="marketing" gradient onClick={(e) => handlePrevStep(e)}>
                        Previous
                      </CustomButton>
                      <span />
                      <button aria-hidden type="submit" className="nextBtn nextPrevBtn" disabled={loader || !!error}>
                        {loader ? (
                          <>
                            Sending... <SubmitLoader />
                          </>
                        ) : (
                          <CustomButton variant="marketing" gradient>
                            Next
                          </CustomButton>
                        )}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Container>

      <p className="px-4 text-white text-xl d-flex justify-content-between fw-bold">
        <span>
          Step {currentStep + 1} of {totalSteps + 1}
        </span>
      </p>
      <div style={{ width: getActiveStep === 2 ? "60%" : "40%" }} className="signupProgressBar" />
    </div>
  );
}

export default connect(null, { profileSetupAction })(MemberProfile);
